import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import CustomerListUI from '../../components/finapp/vendor/CustomerListUI'
import VendorAddModalUI from './../../components/finapp/vendor/VendorAddModalUI';
import VendorUpdateModalUI from './../../components/finapp/vendor/VendorUpdateModalUI';

const CustomerListPageUI = ({ context, messageList, customerList, filteredCustomerList,
  // filters
  searchFilter, onSearchFilterChange,
  // form
  successMsg, errorList, setErrorList,
  // modes
  selectedCount, createMode, updateMode, deleteMode, submitted,
  // event handlers
  onRowClick, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick,
  // event handlers in modals
  onConfirmCreateClick, onConfirmUpdateClick, onConfirmDeleteClick, onCancelClick,
  // update form
  roleId, roleList, onRoleIdChange,
  //
  customerName, onCustomerNameChange, customerNameError, setCustomerNameError,
  // contact attributes and methods
  firstName, lastName, firstNameError, lastNameError, setFirstNameError, setLastNameError, onFirstNameChange, onLastNameChange,
  // phoneNumber attributes and methods
  phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
  // email attributes and methods
  email, onEmailChange, emailError, setEmailError

}) =>
  <PrivatePageSF context={context} className='pg_acc_cust' backLink='/home'
    centered={!customerList || customerList.length === 0 || (errorList && errorList.length > 0)}
    messageList={messageList} headerText='Customers'>
    {
      !customerList && !(errorList && errorList.length) > 0 &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      customerList && customerList.length === 0 && !(errorList && errorList.length) > 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateClick}
        label='Create Customer'
        createDisabledMessageLabel='No Customer'
      />
    }
    {
      customerList && customerList.length > 0 && !(errorList && errorList.length) > 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/home' messageList={messageList} titleText='Customers' />
        <CustomerListUI
          context={context}
          customerList={filteredCustomerList}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          //
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
        />
      </div>
    }
    <VendorAddModalUI
      createMode={createMode}
      context={context}
      messageList={messageList}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onCancelClick={onCancelClick}
      onConfirmCreateClick={onConfirmCreateClick}
      submitted={submitted}
      // 
      customerName={customerName}
      onCustomerNameChange={onCustomerNameChange}
      customerNameError={customerNameError}
      setCustomerNameError={setCustomerNameError}
      // contact attributes and methods
      firstName={firstName}
      lastName={lastName}
      onFirstNameChange={onFirstNameChange}
      onLastNameChange={onLastNameChange}
      firstNameError={firstNameError}
      lastNameError={lastNameError}
      setFirstNameError={setFirstNameError}
      setLastNameError={setLastNameError}
      // phoneNumber attributes and methods
      phoneNumber={phoneNumber}
      onPhoneNumberChange={onPhoneNumberChange}
      phoneNumberError={phoneNumberError}
      setPhoneNumberError={setPhoneNumberError}
      // email attributes and methods
      email={email}
      onEmailChange={onEmailChange}
      emailError={emailError}
      setEmailError={setEmailError}
    />

    <VendorUpdateModalUI
      updateMode={updateMode}
      context={context}
      messageList={messageList}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onCancelClick={onCancelClick}
      onConfirmUpdateClick={onConfirmUpdateClick}
      submitted={submitted}
      //
      customerName={customerName}
      onCustomerNameChange={onCustomerNameChange}
      customerNameError={customerNameError}
      setCustomerNameError={setCustomerNameError}
      // contact attributes and methods
      firstName={firstName}
      lastName={lastName}
      onFirstNameChange={onFirstNameChange}
      onLastNameChange={onLastNameChange}
      firstNameError={firstNameError}
      lastNameError={lastNameError}
      setFirstNameError={setFirstNameError}
      setLastNameError={setLastNameError}
      // phoneNumber attributes and methods
      phoneNumber={phoneNumber}
      onPhoneNumberChange={onPhoneNumberChange}
      phoneNumberError={phoneNumberError}
      setPhoneNumberError={setPhoneNumberError}
      // email attributes and methods
      email={email}
      onEmailChange={onEmailChange}
      emailError={emailError}
      setEmailError={setEmailError}
    />
  </PrivatePageSF>

export default CustomerListPageUI
